import React from 'react';

function normalizeToken(value?: string | null) {
  return String(value || '').trim().toLowerCase();
}

function titleCaseToken(value: string) {
  return value
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatEmailClassification(value?: string | null) {
  const normalized = normalizeToken(value);
  return normalized ? titleCaseToken(normalized) : 'Unclassified';
}

function getClassificationTone(value?: string | null) {
  const normalized = normalizeToken(value);
  switch (normalized) {
    case 'invoice_payment':
      return 'invoice';
    case 'project_update':
      return 'project';
    case 'rfi_question':
      return 'rfi';
    case 'site_issue':
      return 'site';
    case 'quote_inquiry':
      return 'quote';
    case 'document_submission':
      return 'document';
    case 'low_value_noise':
      return 'noise';
    case 'general_admin':
      return 'admin';
    default:
      return 'unknown';
  }
}

function getReviewTone(value?: string | null) {
  const normalized = normalizeToken(value);
  if (normalized === 'accepted') return 'accepted';
  if (normalized === 'rejected') return 'rejected';
  return 'pending';
}

export function EmailClassificationBadge({ value }: { value?: string | null }) {
  const tone = getClassificationTone(value);
  return (
    <span className={`company-ai-classification-badge company-ai-classification-badge--${tone}`}>
      {formatEmailClassification(value)}
    </span>
  );
}

export function EmailReviewStatusBadge({ value }: { value?: string | null }) {
  const tone = getReviewTone(value);
  const label = normalizeToken(value) ? titleCaseToken(normalizeToken(value)) : 'Pending';
  return (
    <span className={`company-ai-review-status-badge company-ai-review-status-badge--${tone}`}>
      {label}
    </span>
  );
}
